document.addEventListener('DOMContentLoaded', function () {
  const videoItems = document.querySelectorAll('.m3-video-masonry .video-masonry__item-inner');

  videoItems.forEach((item) => {
    const video = item.querySelector('video.custom-video');
    const volumeButton = item.querySelector('.video-display__volume-button');
    if (!video) return;

    video.loop = false;
    video.removeAttribute('loop');
    video.muted = true;

    let startSeconds = parseFloat(video.getAttribute('data-start-seconds')) || 0;
    let endSeconds = parseFloat(video.getAttribute('data-end-seconds')) || 0;
    if (startSeconds < 0) startSeconds = 0;
    if (endSeconds <= startSeconds) endSeconds = 0;

    let seekingToStart = false;

    function playFromStart() {
      if (!item.classList.contains('is-hovered')) return;

      const seekAndPlay = function () {
        if (!item.classList.contains('is-hovered')) return;

        if (startSeconds > 0 && Math.abs(video.currentTime - startSeconds) > 0.2) {
          seekingToStart = true;
          const onSeeked = function () {
            video.removeEventListener('seeked', onSeeked);
            seekingToStart = false;
            if (item.classList.contains('is-hovered')) {
              video.play().catch(function () {});
            }
          };
          video.addEventListener('seeked', onSeeked);
          try {
            video.currentTime = startSeconds;
          } catch (err) {
            seekingToStart = false;
            video.play().catch(function () {});
          }
          return;
        }

        video.play().catch(function () {});
      };

      if (video.readyState >= 1) {
        seekAndPlay();
      } else {
        video.addEventListener('loadedmetadata', seekAndPlay, { once: true });
        video.load();
      }
    }

    item.addEventListener('mouseenter', () => {
      item.classList.add('is-hovered');
      playFromStart();
    });

    item.addEventListener('mouseleave', () => {
      item.classList.remove('is-hovered');
      video.pause();
      video.muted = true;
      if (volumeButton) volumeButton.classList.remove('is-unmuted');
      video.load();
    });

    video.addEventListener('timeupdate', () => {
      if (seekingToStart || !endSeconds || !item.classList.contains('is-hovered')) return;
      if (video.currentTime >= endSeconds) {
        seekingToStart = true;
        video.currentTime = startSeconds;
        video.play().catch(() => {});
      }
    });

    video.addEventListener('seeked', () => {
      seekingToStart = false;
    });

    video.addEventListener('ended', () => {
      if (!item.classList.contains('is-hovered')) return;
      playFromStart();
    });

    if (volumeButton) {
      volumeButton.addEventListener('click', (e) => {
        e.stopPropagation();

        video.muted = !video.muted;
        volumeButton.classList.toggle('is-unmuted', !video.muted);
      });
    }
  });
});

(function(){
  const DESKTOP_MQ = '(min-width: 992px)';

  function isDesktop(){
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function prefersReducedMotion(){
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getGroupHeight(group){
    if (!group) return 0;
    if (group.offsetHeight > 1) return group.offsetHeight;

    let max = 0;
    group.querySelectorAll('.video-masonry__item-outer').forEach((item) => {
      max = Math.max(max, item.getBoundingClientRect().height);
    });
    return max;
  }

  function initSection(root){
    if (!root || root.dataset.masonryReady === 'true') return;
    root.dataset.masonryReady = 'true';

    const groupWrap = root.querySelector('.video-masonry__contents');
    const groups = Array.from(root.querySelectorAll('.video-masonry__group'));
    const blocks = Array.from(root.querySelectorAll('.video-masonry__item-outer[data-group]'));
    if (!groupWrap || !groups.length) return;

    let currentIndex = 0;
    let wheelLock = false;
    let isSnapping = false;

    function setActiveGroup(index, resize){
      currentIndex = Math.max(0, Math.min(index, groups.length - 1));
      groups.forEach((group, i) => {
        group.classList.toggle('active', i === currentIndex);
      });
      blocks.forEach((block) => {
        block.classList.toggle('active', Number(block.dataset.group) === currentIndex);
      });
      if (resize !== false) applyStageHeight();
    }

    function applyStageHeight(){
      if (!isDesktop()){
        groupWrap.style.height = '';
        root.classList.remove('is-ready');
        groups.forEach((group) => group.classList.add('active'));
        blocks.forEach((block) => block.classList.add('active'));
        currentIndex = 0;
        return;
      }

      const group = groups[currentIndex] || groups[0];
      const height = getGroupHeight(group);
      if (height > 0) {
        const nextHeight = Math.ceil(height) + 'px';
        if (groupWrap.style.height !== nextHeight) {
          groupWrap.style.height = nextHeight;
        }
        root.classList.add('is-ready');
      }
    }

    function updateActiveFromScroll(){
      if (!isDesktop() || isSnapping) return;

      const wrapTop = groupWrap.getBoundingClientRect().top;
      let closest = 0;
      let closestDist = Infinity;

      groups.forEach((group, i) => {
        const dist = Math.abs(group.getBoundingClientRect().top - wrapTop);
        if (dist < closestDist){
          closestDist = dist;
          closest = i;
        }
      });

      if (closest !== currentIndex) setActiveGroup(closest);
    }

    function snapTo(index){
      const group = groups[index];
      if (!group) return;

      const previousIndex = currentIndex;
      const previousHeight = getGroupHeight(groups[previousIndex]);
      const nextHeight = getGroupHeight(group);
      const grows = nextHeight >= previousHeight;

      isSnapping = true;
      setActiveGroup(index, grows);

      const wrapRect = groupWrap.getBoundingClientRect();
      const groupRect = group.getBoundingClientRect();
      groupWrap.scrollTo({
        top: groupWrap.scrollTop + (groupRect.top - wrapRect.top),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });

      window.setTimeout(function(){
        applyStageHeight();
        isSnapping = false;
      }, prefersReducedMotion() ? 0 : 450);
    }

    function shouldCaptureWheel(deltaY){
      if (!isDesktop() || groups.length < 2) return false;

      const rect = groupWrap.getBoundingClientRect();
      const inView = rect.top < window.innerHeight * 0.55 && rect.bottom > window.innerHeight * 0.35;
      if (!inView) return false;

      if (deltaY > 0) return currentIndex < groups.length - 1;
      if (deltaY < 0) return currentIndex > 0;
      return false;
    }

    function onWheel(e){
      if (!shouldCaptureWheel(e.deltaY)) return;
      e.preventDefault();
      if (wheelLock) return;

      wheelLock = true;
      snapTo(currentIndex + (e.deltaY > 0 ? 1 : -1));
      window.setTimeout(function(){ wheelLock = false; }, 700);
    }

    function sizeStage(){
      applyStageHeight();
      if (isDesktop()) updateActiveFromScroll();
    }

    groupWrap.addEventListener('scroll', updateActiveFromScroll, { passive: true });
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('resize', sizeStage);
    window.addEventListener('load', sizeStage);

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(sizeStage);
      groups.forEach((group) => resizeObserver.observe(group));
    }

    sizeStage();
  }

  function initAll(){
    document.querySelectorAll('.m3-video-masonry').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

(function(){
  let observer;

  function initFloatingCheckoutToggle(){
    const cardStages = document.querySelectorAll('.m3-video-masonry .video-masonry__contents');
    const checkouts = document.querySelectorAll('.product-checkout__floating-checkout');
    if (!cardStages.length || !checkouts.length) return;

    if (observer) observer.disconnect();

    const inView = new Set();

    function apply(){
      const hide = inView.size > 0;
      checkouts.forEach((el) => el.classList.toggle('is-hidden-by-masonry', hide));
    }

    observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) inView.add(entry.target);
        else inView.delete(entry.target);
      });
      apply();
    }, { threshold: 0.2 });

    cardStages.forEach(function(el){ observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingCheckoutToggle);
  } else {
    initFloatingCheckoutToggle();
  }

  document.addEventListener('shopify:section:load', initFloatingCheckoutToggle);
})();
